export function normalizeListIndentation(html: string): string {
  const div = document.createElement('div');
  div.innerHTML = html;

  // Convert any ordered lists to unordered lists
  div.querySelectorAll('ol').forEach((ol) => {
    const ul = document.createElement('ul');
    while (ol.firstChild) {
      ul.appendChild(ol.firstChild);
    }
    ol.replaceWith(ul);
  });

  const lists = div.querySelectorAll('ul');
  lists.forEach((list) => {
    const items = Array.from(list.children) as HTMLElement[];
    let parent: HTMLElement | null = null;
    items.forEach((li) => {
      const indentClass = Array.from(li.classList).find((c) => c.startsWith('ql-indent-'));
      if (indentClass) {
        li.className = '';
        const level = parseInt(indentClass.replace('ql-indent-', ''), 10);
        if (level >= 1 && parent) {
          let sub = parent.querySelector('ul');
          if (!sub) {
            sub = document.createElement('ul');
            parent.appendChild(sub);
          }
          sub.appendChild(li);
        }
      } else {
        parent = li;
      }
    });
  });

  return div.innerHTML;
}
